import { Injectable } from '@angular/core';
import { LocalStorageService } from '../../storage/local-storage.service';
import { normalizePrivilegeKey } from './privilege.utils';

@Injectable({ providedIn: 'root' })
export class AuthorizationService {
  constructor(private localStorageService: LocalStorageService) {}

  can(requiredPrivilege: string | null | undefined): boolean {
    if (!requiredPrivilege) return true;

    const user = this.localStorageService.getCurrentUser();
    if (!user) return false;

    if (user.is_admin === true || user.is_admin_account === true) return true;

    const required = normalizePrivilegeKey(requiredPrivilege);

    // Temporariamente, o acesso às funcionalidades dos módulos é controlado
    // somente pela ativação do módulo na conta. Os privilégios específicos
    // desses módulos permanecem no contrato, mas não restringem a UI.
    if (
      required.startsWith('public_illumination.') ||
      required.startsWith('consumer_unit.')
    ) {
      return true;
    }

    const privileges = user.privileges ?? {};

    return privileges[required] === true ||
      privileges[`${required}.*`] === true ||
      Object.entries(privileges).some(([key, enabled]) =>
        enabled === true && key.endsWith('.*') && required.startsWith(`${key.slice(0, -2)}.`)
      );
  }

  canAny(requiredPrivileges: string[]): boolean {
    return requiredPrivileges.some((privilege) => this.can(privilege));
  }

  canAll(requiredPrivileges: string[]): boolean {
    return requiredPrivileges.every((privilege) => this.can(privilege));
  }
}
